import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'flag',
})
export class flag implements PipeTransform {

    transform(countryName: string, ...args: unknown[]): string {

        switch (countryName) {
            case 'Österreich':
                return 'at';
            case 'Deutschland':
                return 'de';
            case 'Schweiz':
                return 'ch';
            default:
                return '';
        }
    }

}
